/**
 * Logo Container Component
 *
 * Complete logo component combining the Cosimo wordmark and system status badge.
 * Used in navigation bars and headers.
 */
"use client";

import { useRouter } from "next/navigation";

import { LANDING_PAGE_PATH } from "@/lib/landing-page";

import { CosimoLogo } from "./CosimoLogo";
import { SystemStatusButton } from "./SystemStatusButton";

interface LogoContainerProps {
  status?: string;
  showStatus?: boolean;
  className?: string;
  logoClassName?: string;
  statusClassName?: string;
  onClick?: () => void;
}

export function LogoContainer({
  status = "BETA",
  showStatus = true,
  className = "",
  logoClassName = "",
  statusClassName = "",
  onClick,
}: LogoContainerProps) {
  const router = useRouter();

  return (
    <button
      type="button"
      onClick={() => {
        onClick?.();
        router.push(LANDING_PAGE_PATH);
      }}
      className={`inline-flex cursor-pointer items-center gap-[7px] border-0 bg-transparent p-0 ${className}`}
      aria-label="Go to home page"
    >
      <CosimoLogo className={logoClassName} width={58} height={14} />
      {showStatus && <SystemStatusButton status={status} className={statusClassName} />}
    </button>
  );
}
